





































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { EEntities } from '@/types'
import { IChronologyItem } from '@/types/data-objects/item-histories'
import { IProfile } from '@/types/data-objects/profile'
import {
  IAtMentionUser,
  IItemResponder,
  IPersonWithEmail,
  IPriorityLevelForSelection,
  IStatusForSelection,
} from '@/api/types/response.types'
import { IJobInfo } from '@/types/data-objects/items'

/* API */

export default Vue.extend({
  name: 'TaskDetailChronology',

  props: {
    projectId: {
      type: Number,
      required: true,
    },

    taskId: {
      type: Number,
      required: true,
    },

    items: {
      type: Array as () => IChronologyItem[],
      required: true,
    },

    isSubmitting: {
      type: Boolean,
      default: false,
    },

    isTrafficCopChecking: {
      type: Boolean,
      default: false,
    },

    isPostSubmitPreRefetchData: {
      type: Boolean,
      default: false,
    },

    /* Editor */
    mentionUsers: {
      type: Array as () => IAtMentionUser[],
      required: true,
    },

    /* Assignee picker */
    assigneeId: {
      type: Number,
      default: null,
    },

    /* Priority */
    priorityId: {
      type: Number,
      required: true,
    },

    priorityOptions: {
      type: Array as () => IPriorityLevelForSelection[],
      required: true,
    },

    /* Status */
    statusId: {
      type: Number,
      required: true,
    },

    statusOptions: {
      type: Array as () => IStatusForSelection[],
      required: true,
    },

    respondersSinceLastView: {
      type: Array as () => IItemResponder[],
      default: (): IItemResponder[] => [],
    },

    /* Due date */
    dueDate: {
      type: [Date, String],
      default: null,
    },

    /* Watchers picker */
    listWatchers: {
      type: Array as () => number[],
      required: true,
    },

    assigneesOptions: {
      type: Array as () => IPersonWithEmail[],
      required: true,
    },

    watchersOptions: {
      type: Array as () => IPersonWithEmail[],
      required: true,
    },

    profile: {
      type: Object as () => IProfile,
      required: true,
    },

    jobInfo: {
      type: Object as () => IJobInfo,
      default: null,
    },

    commentSubmitHandler: {
      type: Function,
      default: (): any => {},
    },

    hasGuestUsers: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      renderItems: [],
      EEntities,
    }
  },

  computed: {
    hasHistory(): boolean {
      return this.renderItems && this.renderItems.length > 0
    },
  },

  watch: {
    items() {
      this.renderItems = this.items
    },
  },

  mounted() {
    this.renderItems = this.items
  },
})
